/**
 * Always renders a root `<div>` that holds the column's box styles — either
 * around the host component or around the placeholder. The host component is
 * unknown to this library, so it cannot be trusted to carry styles itself.
 */
export const resolveNoContainer = (): boolean => false;
